import * as React from 'react';

import ContrastContext from '../context/contrastContext';
import TextSizeContext from '../context/textSizeContext';
import { Link } from 'gatsby';
import logoWhite from '../img/logo-white.svg';
import { ContrastIcon, TextSizeIcon } from '../components/Icon';

const Footer = class extends React.Component {
  render() {
    return (
      <footer className="footer text-white mt-auto pt-6">
        <div className="container flex items-center justify-between py-5 md:py-7">
          <div className="md:max-w-3xl">
            <Link to="/" className="block w-28 md:w-48 pb-6">
              <img src={logoWhite} alt="GDI" />
            </Link>
            <nav className="grid grid-cols-2 gap-x-8 pb-6 md:hidden text-base">
              <Link className="inline-block py-1" to="/contact">
                Contact
              </Link>
              <Link className="inline-block py-1" to="/careers">
                Jobs
              </Link>
              <Link className="inline-block py-1" to="/privacy">
                Privacy
              </Link>
              <Link className="inline-block py-1" to="https://www.linkedin.com/company/the-global-disinformation-index">
                LinkedIn
              </Link>
            </nav>
            <hr className="border-t border-t-gray-400 pb-6 md:hidden" />
            <div className="inline-flex gap-x-12 md:gap-x-6 mb-4">
              <div>
                <span className="block mb-2">Accessibility:</span>
                <ContrastContext.Consumer>
                  {(contrastContext) => (
                    <>
                      <TextSizeContext.Consumer>
                        {(textContext) => (
                          <div
                            className={`inline-block mr-4 rounded-full border border-white cursor-pointer bg-transparent hover:bg-white ${
                              textContext.isLgTextEnabled
                                ? `${
                                    contrastContext.isHighContrastEnabled
                                      ? 'text-primaryHC'
                                      : 'text-primary'
                                  }`
                                : 'text-white hover:text-black'
                            }`}
                            title={`${
                              textContext.isLgTextEnabled ? 'Disable' : 'Enable'
                            } large font`}
                            tabIndex={0}
                            role="button"
                            onKeyPress={textContext.toggleLgText}
                            onClick={textContext.toggleLgText}
                          >
                            <TextSizeIcon className="w-12 h-12" />
                          </div>
                        )}
                      </TextSizeContext.Consumer>
                      <div
                        className={`inline-block rounded-full border border-white cursor-pointer bg-transparent hover:bg-white ${
                          contrastContext.isHighContrastEnabled
                            ? 'text-primaryHC'
                            : 'text-white hover:text-black'
                        }`}
                        title={`${
                          contrastContext.isHighContrastEnabled
                            ? 'Disable'
                            : 'Enable'
                        } high contrast`}
                        tabIndex={0}
                        role="button"
                        onKeyPress={contrastContext.toggleHighContrast}
                        onClick={contrastContext.toggleHighContrast}
                      >
                        <ContrastIcon className="w-12 h-12" />
                      </div>
                    </>
                  )}
                </ContrastContext.Consumer>
              </div>
            </div>
            <p className="text-xs">
            
            
              © Copyright - Disinformation Index Ltd., All Rights Reserved.
              GDI is a not-for-profit company; any surplus income generated will be
              100% reinvested back into the organisation to further its mission.
              Disinformation Index Ltd is a company limited by guarantee registered in England and Wales under company number 11297397.
              Registered office: 124 City Road, London, England, EC1V 2NX.
              
            </p>
          </div>
          <nav className="hidden md:grid grid-cols-2 gap-x-16 text-base">
            <div className="my-1 pb-2">
              <Link to="/contact" className="inline hover:bg-theme-underline">
                Contact
              </Link>
            </div>
            <div className="my-1 pb-2">
              <Link to="/careers" className="inline hover:bg-theme-underline">
                Jobs
              </Link>
            </div>
            <div className="my-1 pb-2">
              <Link to="/privacy" className="inline hover:bg-theme-underline">
                Privacy
              </Link>
            </div>
            <div className="my-1 pb-2">
              <Link to="https://www.linkedin.com/company/the-global-disinformation-index" className="inline hover:bg-theme-underline">
                LinkedIn
              </Link>
            </div>
          </nav>
        </div>
      </footer>
    );
  }
};

export default Footer;
